function makeEventRouter() {
    const router = {
        '': { execute: async () => { } }
    };
    const routerWithData = {};
    return Object.freeze({
        get,
        getWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
